<template>
  <div v-if="currentStyle">
    <template v-for="input of inputs">
      <ruleGroupInput
        v-if="input.children && input.children.length > 0"
        :key="input.value"
        :field="input"
        v-model="currentStyle"
        @input="changeStyle"
        :autocomplete="input.autocomplete"
      />
      <rule-field-name
        v-else-if="input.type == 'field-label'"
        :label="input.label"
        :key="input.value + '-label'"
        :fields="fields"
        :option="input.option"
        v-model="currentStyle[input.value]"
        @input="changeStyle"
        :autocomplete="input.autocomplete"
      ></rule-field-name>
      <rule-field-array
        v-else-if="input.type == 'field-array'"
        :label="input.label"
        :key="input.value + '-array'"
        :fields="fields"
        :option="input.option"
        v-model="currentStyle[input.value]"
        @input="changeStyle"
        :autocomplete="input.autocomplete"
      ></rule-field-array>
      <rule-field-image
        v-else-if="input.type == 'image'"
        :label="input.label"
        :key="input.value + '-image'"
        v-model="currentStyle[input.value]"
        @input="changeStyle"
        :autocomplete="input.autocomplete"
      ></rule-field-image>
      <ruleInput
        v-else
        :typeInput="input.type"
        :label="input.label"
        :key="input.value + '-else'"
        :option="input.option"
        v-model="currentStyle[input.value]"
        @input="changeStyle"
        :autocomplete="input.autocomplete"
      ></ruleInput>
    </template>

    <v-btn
      v-if="otherInput.length > 0"
      text
      @click="isAdvanced = !isAdvanced"
      :color="isAdvanced ? 'primary' : ''"
    >
      {{ $t('preview.actions.advanced') }}
    </v-btn>
    <template v-if="isAdvanced">
      <template v-for="input of otherInput">
        <ruleGroupInput
          v-if="input.children && input.children.length > 0"
          :key="input.value"
          :field="input"
          v-model="currentStyle"
          @input="changeStyle"
          :autocomplete="input.autocomplete"
        />
        <rule-field-name
          v-else-if="input.type == 'field-label'"
          :label="input.label"
          :key="input.value + '-label'"
          :fields="fields"
          :option="input.option"
          v-model="currentStyle[input.value]"
          @input="changeStyle"
          :autocomplete="input.autocomplete"
        ></rule-field-name>
        <rule-field-array
          v-else-if="input.type == 'field-array'"
          :label="input.label"
          :key="input.value + '-array'"
          :fields="fields"
          :option="input.option"
          v-model="currentStyle[input.value]"
          @input="changeStyle"
          :autocomplete="input.autocomplete"
        ></rule-field-array>
        <rule-field-image
          v-else-if="input.type == 'image'"
          :label="input.label"
          :key="input.value + '-image'"
          v-model="currentStyle[input.value]"
          @input="changeStyle"
          :autocomplete="input.autocomplete"
        ></rule-field-image>
        <rule-font
          v-else-if="input.type == 'font'"
          :label="input.label"
          :key="input.value + '-font'"
          v-model="currentStyle[input.value]"
          @input="changeStyle"
          :autocomplete="input.autocomplete"
        ></rule-font>
        <ruleInput
          v-else
          :typeInput="input.type"
          :label="input.label"
          :key="input.value + '-else'"
          :option="input.option"
          v-model="currentStyle[input.value]"
          @input="changeStyle"
          :autocomplete="input.autocomplete"
        ></ruleInput>
      </template>
    </template>
  </div>
</template>

<script>
import asyncComponent from '@/src/components/async'

import ruleGroupInput from '../input/edit-rule-group-input.vue'
import ruleInput from '../input/edit-rule-input.vue'

export default {
  components: {
    ruleInput,
    ruleGroupInput,
    RuleFieldName: () => asyncComponent(import('../input/rule-field-name.vue')),
    RuleFieldArray: () =>
      asyncComponent(import('../input/rule-field-array.vue')),
    RuleFieldImage: () =>
      asyncComponent(import('../input/rule-field-image.vue')),
    RuleFont: () => asyncComponent(import('../input/rule-font.vue')),
  },
  props: {
    value: {},
    typeLayer: String,
    fields: { type: Array },
  },
  data: () => ({
    isAdvanced: false,
    otherInput: [],
    inputs: [],
    currentStyle: {},
  }),
  watch: {
    value: {
      handler(value) {
        this.currentStyle = value || {}
      },
      immediate: true,
      deep: true,
    },
    typeLayer: {
      handler(value) {
        let input = defautInput[value] || Text
        this.inputs = [...DEFAULT_OPTION.default, ...input.default]
        this.otherInput = [...DEFAULT_OPTION.other, ...input.other]
        this.isAdvanced = false
      },
      immediate: true,
    },
  },
  methods: {
    changeStyle() {
      this.$emit('input', this.currentStyle)
    },
  },
}

const Point = {
  default: [
    {
      label: 'Độ lệch chữ',
      value: 'text-offset',
      type: 'field-array',
      defaultValue: [0, 1],
    },
    {
      label: 'Bỏ qua va chạm',
      value: 'text-ignore-placement',
      type: 'v-checkbox',
      defaultValue: true,
    },
  ],
  other: [],
}

const Line = {
  default: [
    {
      label: 'Vị trí nhãn',
      value: 'symbol-placement',
      type: 'v-select',
      defaultValue: 'line',
      option: {
        items: [
          { text: 'Point', value: 'point' },
          { text: 'Line', value: 'line' },
          { text: 'Line center', value: 'line-center' },
        ],
      },
    },
  ],
  other: [
    {
      label: 'Giữ nhãn thẳng đứng',
      value: 'text-keep-upright',
      type: 'v-checkbox',
      defaultValue: true,
    },
    {
      label: 'Khoảng cách lặp',
      value: 'symbol-spacing',
      type: 'length',
      defaultValue: 250,
    },
  ],
}

const Polygon = {
  default: [],
  other: [
    {
      label: 'Giới hạn chiều rộng',
      value: 'text-max-width',
      type: 'length',
      defaultValue: 10,
    },
  ],
}
let DEFAULT_OPTION = {
  default: [
    {
      label: 'Cỡ chữ',
      value: 'text-size',
      type: 'length',
      acceptsExpression: true,
      defaultValue: 16,
    },
    {
      label: 'Phông chữ',
      value: 'text-font',
      type: 'font',
      defaultValue: 'Arial Regular',
    },
    {
      label: 'Màu chữ',
      value: 'text-color',
      type: 'color',
      acceptsExpression: true,
      defaultValue: '#333333',
    },
    {
      label: 'Màu viền chữ',
      value: 'text-halo-color',
      type: 'color',
      acceptsExpression: true,
      defaultValue: '#ffffff',
    },
    {
      label: 'Độ trong suốt',
      value: 'text-opacity',
      type: 'percentage',
      acceptsExpression: true,
      defaultValue: 1,
    },
    {
      label: 'Độ dày viền chữ',
      value: 'text-halo-width',
      type: 'length',
      acceptsExpression: true,
      defaultValue: 0,
    },
    {
      label: 'Độ mờ viền chữ',
      value: 'text-halo-blur',
      type: 'length',
      acceptsExpression: true,
      defaultValue: 0,
    },
  ],
  other: [
    {
      label: 'Kiểu chữ',
      value: 'text-transform',
      type: 'v-select',
      defaultValue: 'none',
      option: {
        items: [
          { text: 'Mặc định', value: 'none' },
          { text: 'In hoa', value: 'uppercase' },
          { text: 'In thường', value: 'lowercase' },
        ],
      },
    },
    {
      label: 'Neo chữ',
      value: 'text-anchor',
      type: 'v-select',
      defaultValue: 'center',
      option: {
        items: [
          { text: 'center', value: 'center' },
          { text: 'left', value: 'left' },
          { text: 'right', value: 'right' },
          { text: 'top', value: 'top' },
          { text: 'bottom', value: 'bottom' },
          { text: 'top-left', value: 'top-left' },
          { text: 'top-right', value: 'top-right' },
          { text: 'bottom-left', value: 'bottom-left' },
          { text: 'bottom-right', value: 'bottom-right' },
        ],
      },
    },
    {
      label: 'Canh đều',
      value: 'text-justify',
      type: 'v-select',
      defaultValue: 'auto',
      option: {
        items: [
          { text: 'auto', value: 'auto' },
          { text: 'left', value: 'left' },
          { text: 'center', value: 'center' },
          { text: 'right', value: 'right' },
        ],
      },
    },
    {
      label: 'Xoay chữ',
      value: 'text-rotate',
      type: 'number',
      acceptsExpression: true,
      defaultValue: 0,
    },
    {
      label: 'Cho phép chồng lấp',
      value: 'text-allow-overlap',
      type: 'v-checkbox',
      defaultValue: false,
    },
    {
      label: 'Padding va chạm',
      value: 'text-padding',
      type: 'length',
      defaultValue: 2,
    },
  ],
}
let defautInput = { Point, Polygon, Line }
</script>

<style></style>
